export function ArrowRight(props) {
	return (
		<svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25">
			<path
				style={{ fill: '#006EF4' }}
				d="m17.5 5.999-.707.707 5.293 5.293H1v1h21.086l-5.294 5.295.707.707L24 12.499l-6.5-6.5z"
				data-name="Right"
			/>
		</svg>
	);
}

export function Instagram(props) {
	return (
		<svg
			{...props}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect x="3" y="3" width="18" height="18" rx="5" stroke="currentColor" strokeWidth="2" />
			<circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="2" />
			<circle cx="17.4" cy="6.6" r="1.1" fill="currentColor" />
		</svg>
	);
}

export function Location(props) {
	return (
		<svg
			{...props}
			viewBox="0 0 53 67"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M26.4996 0.583252C11.9801 0.583252 0.166284 12.397 0.166284 26.9001C0.0708254 48.1149 25.4989 65.7056 26.4996 66.4166C26.4996 66.4166 52.9284 48.1149 52.833 26.9166C52.833 12.397 41.0192 0.583252 26.4996 0.583252ZM26.4996 40.0833C19.225 40.0833 13.333 34.1912 13.333 26.9166C13.333 19.642 19.225 13.7499 26.4996 13.7499C33.7742 13.7499 39.6663 19.642 39.6663 26.9166C39.6663 34.1912 33.7742 40.0833 26.4996 40.0833Z"
				fill="#006EF4"
			/>
		</svg>
	);
}
export function Hour(props) {
	return (
		<svg
			{...props}
			viewBox="0 0 69 69"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M34.5 64.125C50.8614 64.125 64.125 50.8614 64.125 34.5C64.125 18.1386 50.8614 4.875 34.5 4.875C18.1386 4.875 4.875 18.1386 4.875 34.5C4.875 50.8614 18.1386 64.125 34.5 64.125Z"
				stroke="#006EF4"
				stroke-width="8.22917"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M31.209 21.3335V37.7918H47.6673"
				stroke="#006EF4"
				stroke-width="8.22917"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	);
}
export function Msg(props) {
	return (
		<svg
			{...props}
			viewBox="0 0 48 48"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clip-path="url(#clip0_10_216)">
				<path
					d="M10.695 33.968C10.9545 34.2285 11.1533 34.543 11.2774 34.8891C11.4014 35.2352 11.4475 35.6045 11.4125 35.9705C11.2368 37.6644 10.9037 39.3383 10.4175 40.9705C13.905 40.163 16.035 39.228 17.0025 38.738C17.5513 38.46 18.1832 38.3942 18.7775 38.553C20.4811 39.0071 22.2369 39.2358 24 39.233C33.99 39.233 41.5 32.2155 41.5 24.2329C41.5 16.2529 33.99 9.23292 24 9.23292C14.01 9.23292 6.5 16.2529 6.5 24.2329C6.5 27.903 8.0425 31.308 10.695 33.968ZM9.4625 43.7305C8.87017 43.8479 8.27592 43.9554 7.68 44.053C7.18 44.133 6.8 43.613 6.9975 43.148C7.21948 42.6245 7.42294 42.0933 7.6075 41.5555L7.615 41.5305C8.235 39.7305 8.74 37.6605 8.925 35.733C5.8575 32.658 4 28.633 4 24.2329C4 14.5679 12.955 6.73291 24 6.73291C35.045 6.73291 44 14.5679 44 24.2329C44 33.898 35.045 41.733 24 41.733C22.0191 41.7357 20.0465 41.4785 18.1325 40.968C16.8325 41.6255 14.035 42.823 9.4625 43.7305Z"
					fill="#0053B8"
					stroke="#0053B8"
				/>
			</g>
			<defs>
				<clipPath id="clip0_10_216">
					<rect width="48" height="48" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}
export function Mail(props) {
	return (
		<svg
			{...props}
			viewBox="0 0 48 48"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M44 12C44 9.8 42.2 8 40 8H8C5.8 8 4 9.8 4 12V36C4 38.2 5.8 40 8 40H40C42.2 40 44 38.2 44 36V12ZM40 12L24 22L8 12H40ZM40 36H8V16L24 26L40 16V36Z"
				fill="#0053B8"
			/>
		</svg>
	);
}
export function Phone2(props) {
	return (
		<svg
			fill="#0053B8"
			height="200px"
			width="200px"
			id="Capa_1"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			viewBox="0 0 473.806 473.806"
			xmlSpace="preserve"
			stroke="#0053B8"
			{...props}
		>
			<g id="SVGRepo_bgCarrier" strokeWidth={0} />
			<g
				id="SVGRepo_tracerCarrier"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<g id="SVGRepo_iconCarrier">
				{"\n\t\t\t\t{' '}\n\t\t\t\t"}
				<g>
					{"\n\t\t\t\t\t{' '}\n\t\t\t\t\t"}
					<g>
						{"\n\t\t\t\t\t\t{' '}\n\t\t\t\t\t\t"}
						<path d="M374.456,293.506c-9.7-10.1-21.4-15.5-33.8-15.5c-12.3,0-24.1,5.3-34.2,15.4l-31.6,31.5c-2.6-1.4-5.2-2.7-7.7-4 c-3.6-1.8-7-3.5-9.9-5.3c-29.6-18.8-56.5-43.3-82.3-75c-12.5-15.8-20.9-29.1-27-42.6c8.2-7.5,15.8-15.3,23.2-22.8 c2.8-2.8,5.6-5.7,8.4-8.5c21-21,21-48.2,0-69.2l-27.3-27.3c-3.1-3.1-6.3-6.3-9.3-9.5c-6-6.2-12.3-12.6-18.8-18.6 c-9.7-9.6-21.3-14.7-33.5-14.7s-24,5.1-34,14.7c-0.1,0.1-0.1,0.1-0.2,0.2l-34,34.3c-12.8,12.8-20.1,28.4-21.7,46.5 c-2.4,29.2,6.2,56.4,12.8,74.2c16.2,43.7,40.4,84.2,76.5,127.6c43.8,52.3,96.5,93.6,156.7,122.7c23,10.9,53.7,23.8,88,26 c2.1,0.1,4.3,0.2,6.3,0.2c23.1,0,42.5-8.3,57.7-24.8c0.1-0.2,0.3-0.3,0.4-0.5c5.2-6.3,11.2-12,17.5-18.1c4.3-4.1,8.7-8.4,13-12.9 c9.9-10.3,15.1-22.3,15.1-34.6c0-12.4-5.3-24.3-15.4-34.3L374.456,293.506z M410.256,398.806 C410.156,398.806,410.156,398.906,410.256,398.806c-3.9,4.2-7.9,8-12.2,12.2c-6.5,6.2-13.1,12.7-19.3,20 c-10.1,10.8-22,15.9-37.6,15.9c-1.5,0-3.1,0-4.6-0.1c-29.7-1.9-57.3-13.5-78-23.4c-56.6-27.4-106.3-66.3-147.6-115.6 c-34.1-41.1-56.9-79.1-72-119.9c-9.3-24.9-12.7-44.3-11.2-62.6c1-11.7,5.5-21.4,13.8-29.7l34.1-34.1c4.9-4.6,10.1-7.1,15.2-7.1 c6.3,0,11.4,3.8,14.6,7c0.1,0.1,0.2,0.2,0.3,0.3c6.1,5.7,11.9,11.6,18,17.9c3.1,3.2,6.3,6.4,9.5,9.7l27.3,27.3 c10.6,10.6,10.6,20.4,0,31c-2.9,2.9-5.7,5.8-8.6,8.6c-8.4,8.6-16.4,16.6-25.1,24.4c-0.2,0.2-0.4,0.3-0.5,0.5 c-8.6,8.6-7,17-5.2,22.7c0.1,0.3,0.2,0.6,0.3,0.9c7.1,17.2,17.1,33.4,32.3,52.7l0.1,0.1c27.6,34,56.7,60.5,88.8,80.8 c4.1,2.6,8.3,4.7,12.3,6.7c3.6,1.8,7,3.5,9.9,5.3c0.4,0.2,0.8,0.5,1.2,0.7c3.4,1.7,6.6,2.5,9.9,2.5c8.3,0,13.5-5.2,15.2-6.9 l34.2-34.2c3.4-3.4,8.8-7.5,15.1-7.5c6.2,0,11.3,3.9,14.4,7.3c0.1,0.1,0.1,0.1,0.2,0.2l55.1,55.1 C420.456,377.706,420.456,388.206,410.256,398.806z" />
						{"{' '}\n\t\t\t\t\t\t"}
						<path d="M256.056,112.706c26.2,4.4,50,16.8,69,35.8s31.3,42.8,35.8,69c1.1,6.6,6.8,11.2,13.3,11.2c0.8,0,1.5-0.1,2.3-0.2 c7.4-1.2,12.3-8.2,11.1-15.6c-5.4-31.7-20.4-60.6-43.3-83.5s-51.8-37.9-83.5-43.3c-7.4-1.2-14.3,3.7-15.6,11 S248.656,111.506,256.056,112.706z" />
						{"{' '}\n\t\t\t\t\t\t"}
						<path d="M473.256,209.006c-8.9-52.2-33.5-99.7-71.3-137.5s-85.3-62.4-137.5-71.3c-7.3-1.3-14.2,3.7-15.5,11 c-1.2,7.4,3.7,14.3,11.1,15.6c46.6,7.9,89.1,30,122.9,63.7c33.8,33.8,55.8,76.3,63.7,122.9c1.1,6.6,6.8,11.2,13.3,11.2 c0.8,0,1.5-0.1,2.3-0.2C469.556,223.306,474.556,216.306,473.256,209.006z" />
						{"{' '}\n\t\t\t\t\t"}
					</g>
					{"{' '}\n\t\t\t\t"}
				</g>
				{"{' '}\n\t\t\t"}
			</g>
		</svg>
	);
}
